<template>
  <div
    v-if="initialized"
    class="flex h-full w-full"
    :class="{ 'flex-col': mq.isMobile }"
  >
    <NavbarDesktopSupervisor />
    <main
      id="page"
      class="h-full w-full p-5 overflow-y-auto"
    >
      <router-view />
    </main>
  </div>
</template>

<script>
import NavbarDesktopSupervisor from '@/app/_supervisors/components/navbar/TheNavbarDesktopSupervisor.vue';
import profile_mixin from '@/app/util/profile_mixin';

export default {
  name: 'Supervisor',
  components: {
    NavbarDesktopSupervisor,
  },
  mixins: [profile_mixin],

  async created() {
    await this.initProfile();
  },
};
</script>
